import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import BootstrapVue from 'bootstrap-vue';
import Store from './store/store';
import VModal from 'vue-js-modal';
import moment from 'moment';
import './components/components';
import VueAsyncComputed from 'vue-async-computed';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import ConfigurationService from './services/ConfigurationService';
import { setServiceErrorHandler } from './services/HttpHelper';

Vue.use(VueRouter);
Vue.use(VueAsyncComputed);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(VueMeta);

Vue.filter('date', function(value, format) {
	if (value) {
		return moment(String(value)).format(format || 'DD/MM/YYYY');
	}
});

Vue.directive('scrollTo', {
	inserted: function (el, binding) {
    el.scrollIntoView({ behavior: 'smooth', block: binding['value']});
  }
});

const router = new VueRouter({
	linkActiveClass: "active",
	routes: routes,
	mode: "history" //serve para tirar o hash da barra de endereco do navegador
});

let serviceErrorNavigationPending = false;
setServiceErrorHandler(() => {
  if (serviceErrorNavigationPending || router.currentRoute.name === 'server-error') return;

  serviceErrorNavigationPending = true;
  router.replace(
    { name: 'server-error' },
    () => { serviceErrorNavigationPending = false; },
    () => { serviceErrorNavigationPending = false; },
  );
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'server-error') return next();

  const configurationService = new ConfigurationService();
  try {
    const response = await configurationService.getCampaignConfiguration();
    const isUnderMaintenance = response.data.siteUnderMaintenance;
    Store.dispatch("updateMaintenanceStatus", isUnderMaintenance);
    if (isUnderMaintenance && to.name !== "under-maintenance") {
      return next({ name: "under-maintenance" });
    } else if (!isUnderMaintenance && to.name === "under-maintenance") {
      return next({ path: "/" });
    }
    return next();
  } catch (error) {
    return next();
  }
});


new Vue({
	el: '#app',
	router: router,
	store: Store,
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js